import { render, staticRenderFns } from "./detailSwiper.vue?vue&type=template&id=51aa3fd4&scoped=true&"
import script from "./detailSwiper.vue?vue&type=script&lang=js&"
export * from "./detailSwiper.vue?vue&type=script&lang=js&"
import style0 from "./detailSwiper.vue?vue&type=style&index=0&id=51aa3fd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa3fd4",
  null
  
)

export default component.exports